// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {AppScope} from '../../services/app_scope.service';
import {takeUntil} from "rxjs";
import {BaseComponent} from "../../shared/base.component";
import {HeaderDataService} from "../../services/header_data.service";
import {TimezoneSelectorService} from "../../services/timezone-selector.service";
import {RouterOutlet} from "@angular/router";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'subroute-page-outlet',
    templateUrl: './subroute-page-outlet.component.html',
    styleUrls: ['./subroute-page-outlet.component.scss'],
    imports: [
        CommonModule,
        RouterOutlet,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubroutePageOutletComponent extends BaseComponent {
    /**
     * This Component is used to wrap the router output, when loading a submodule module, in a standard WIRE page view.
     */
    currentTheme: string;

    constructor(private appScope: AppScope,
                private cdr: ChangeDetectorRef,
                public headerData: HeaderDataService,
                public timezoneSelectorService: TimezoneSelectorService) {
        super();
        this.appScope.currentTheme.pipe(takeUntil(this.onDestroy)).subscribe((theme: string) => {
            this.currentTheme = theme;
            this.cdr.markForCheck();
        })
    }

    ngOnInit() {
        this.cdr.markForCheck();
    }
}
